import React, { Component } from 'react';
import { Route } from 'react-router';
import { Layout } from './components/Layout';
import Home from './components/Home';
import { Register } from './components/Register';
import EmployeeWorkForm from './components/EmployeeWorkForm';
import { Login } from './components/Login';
import { UserManagement } from './components/UserManagement';
import WorkCategoryManagement from './components/WorkCategoryManagement';
import EmployeeManagement from './components/EmployeeManagement';
import WorkActManagement from './components/WorkActManagement';
import { TokenDebug } from './components/TokenDebug';
import { AuthProvider } from './contexts/AuthContext';

import './custom.css'

export default class App extends Component {
  static displayName = App.name;

  render () {
    return (
      <AuthProvider>
        <Layout>
          <Route exact path='/' component={Home} />
          <Route path='/register' component={Register} />
          <Route path='/employee/:token' component={EmployeeWorkForm} />
          <Route path='/login' component={Login} />
          <Route path='/users' component={UserManagement} />
          <Route path='/work-categories' component={WorkCategoryManagement} />
          <Route path='/employees' component={EmployeeManagement} />
          <Route path='/work-acts' component={WorkActManagement} />
          <Route path='/token-debug' component={TokenDebug} />
        </Layout>
      </AuthProvider>
    );
  }
}
